import { Component, inject, OnInit, signal, OnDestroy } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { IndexIoService } from '../../services/index-io.service';
import { Subscription } from 'rxjs';
import {NgForOf, NgIf} from '@angular/common';
import {DomSanitizer, SafeResourceUrl} from "@angular/platform-browser";
@Component({
  selector: 'bnpp-indx-document-landing',
   imports: [NgIf, NgForOf],
  template: '<iframe *ngIf="pdfUrl()" [src]="pdfUrl()" class="w-full h-full border-0"></iframe>',
  standalone: true,
})
export class DocumentLandingComponent implements OnInit, OnDestroy {
  private route = inject(ActivatedRoute);
  private router = inject(Router);
  private indexService = inject(IndexIoService);
  pdfUrl = signal<SafeResourceUrl | null>(null);
  private subscription?: Subscription;

constructor(private sanitizer: DomSanitizer) {
}
 
ngOnInit(): void {

  const filename = this.route.snapshot.paramMap.get('filename');

  if (filename) {

    const cleanFilename = filename.replace(/\.pdf$/i, '');

    this.subscription = this.indexService.openDocument(cleanFilename).subscribe({

      next: (blob: Blob) => {

        // Convert Blob to Base64 data URL

        const reader = new FileReader();

        reader.onload = () => {

          // reader.result = "data:application/pdf;base64,JVBERi0xLjQK..."

          const dataUrl = reader.result as string;

          const safeDataUrl = this.sanitizer.bypassSecurityTrustResourceUrl(dataUrl);

          this.pdfUrl.set(safeDataUrl);

        };

        reader.readAsDataURL(blob); // Triggers onload

      },

      error: (err) => {

        console.error('Error downloading document:', err);

        this.router.navigate(['/home']);

      }

    });

  } else {

    this.router.navigate(['/home']);

  }

}
 
  public ngOnDestroy(): void {
    this.subscription?.unsubscribe();
  }
}
